<button
	nz-button
	[type]="behaviour"
	[nzType]="type"
	(click)="submitForm ? submitForm.emit() : ''"
	[class]="
		(isDisabled && state === 'outline'
			? 'disabledoutline'
			: isDisabled && state === 'text'
			? 'disabledtext'
			: isSubmitting && state === 'text'
			? 'disabledtext'
			: isSubmitting && state === 'outline'
			? 'disabledoutline'
			: isDisabled
			? 'disabled'
			: state)
			+ (!!class ? ( ' ' + class) : '')
	"
	[disabled]="isDisabled || isSubmitting"
	[nzBlock]="isBlock"
	[nzShape]="shape ? shape : null"
	[nzDanger]="isDanger"
	[nzLoading]="isSubmitting"
	[class.hover]="type !== 'link'"
	[style.border-radius]="roundedBorder ?'8px':undefined"
>
	<ng-container *ngIf="prefixIcon" [ngTemplateOutlet]="prefixIcon"></ng-container>
	<app-button-icons *ngIf="prefix" [icon]="prefix" [theme]="theme" class="button_left_icon align-text-bottom"></app-button-icons>
	{{ !isSubmitting ? (text | translate) : '' }}
	<ng-container *ngIf="suffixIcon" [ngTemplateOutlet]="suffixIcon"></ng-container>
	<app-button-icons *ngIf="suffix" [icon]="suffix" [theme]="theme" class="button_right_icon align-text-bottom"></app-button-icons>
</button>
